export default __webpack_public_path__ + "static/projects_gallery2-afc1e10d210e77169f525cf41f20f89b.webp";